import { render } from "./OcrEditableGrid.vue?vue&type=template&id=7df7bf40"
import script from "./OcrEditableGrid.vue?vue&type=script&lang=js"
export * from "./OcrEditableGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__